import { UseMutationOptions, useQueryClient } from '@tanstack/react-query';

import MutationKeys from 'hooks/mutations/keys';
import QueryKeys from 'hooks/queries/keys';
import useMutation from 'hooks/useMutation';
import { ApiMethods, CuredApiPaths } from 'models/enums';

export type CreateSavedRowInput = {
    name: string;
    category: string;
    row: Record<string, unknown>;
};

export type CreateSavedRowResponse = {
    id: string;
    name: string;
    category: string;
};

/** POST /saved-rows — persist a reusable library row (e.g. Bee self-hosted saved rows). */
const useCreateSavedRow = (mutateOptions?: UseMutationOptions<CreateSavedRowResponse, Error, CreateSavedRowInput>) => {
    const queryClient = useQueryClient();
    const { onSuccess: onSuccessOption, ...restMutateOptions } = mutateOptions ?? {};

    return useMutation<CreateSavedRowInput, CreateSavedRowResponse>(
        MutationKeys.CREATE_SAVED_ROW,
        CuredApiPaths.SAVED_ROWS,
        {
            onSuccess: (data, variables, context) => {
                queryClient.invalidateQueries(QueryKeys.SAVED_ROWS_CATEGORY(variables.category));
                queryClient.invalidateQueries({ queryKey: QueryKeys.SAVED_ROWS_CATEGORY_LIST });
                onSuccessOption?.(data, variables, context);
            },
            ...restMutateOptions,
        },
        ApiMethods.POST
    );
};

export default useCreateSavedRow;
